import { Paper, Stack, Text } from "@mantine/core";
import { IconFile } from "@tabler/icons-react";
import { client } from "@/api-client";
import type { FileOutput, FolderOutput } from "@/api-types";
import { FancyLoader } from "@/components/FancyLoader";
import { LibraryItem } from "@/components/LibraryItem";

interface OwnerGroupFilesProps {
  groupId: string;
  fileIds: string[];
}

export const OwnerGroupFiles = ({ fileIds }: OwnerGroupFilesProps) => {
  // Fetch files for the group
  const { data: fileList, isLoading: isLoadingFiles } = client.useQuery(
    "get",
    "/universal/files-batch/batch-get",
    {
      params: {
        query: {
          fileIds: fileIds,
        },
      },
    },
    {
      enabled: fileIds.length > 0,
    },
  );

  if (isLoadingFiles && fileIds.length > 0) {
    return <FancyLoader />;
  }

  if (fileIds.length === 0) {
    return (
      <Paper p="xl" withBorder>
        <Stack align="center">
          <IconFile size={48} color="gray" />
          <div>
            <Text fw={500} ta="center">
              No files shared
            </Text>
            <Text c="dimmed" ta="center">
              Files shared with this group will appear here
            </Text>
          </div>
        </Stack>
      </Paper>
    );
  }

  return (
    <Stack>
      {fileList?.files?.map((file: FileOutput) => (
        <LibraryItem key={file.id} kind="file" item={file} readonly={true} />
      ))}
      {fileList?.folders?.map((folder: FolderOutput) => (
        <LibraryItem
          key={folder.id}
          kind="folder"
          item={folder}
          readonly={true}
          onFolderClick={() => {}}
        />
      ))}
    </Stack>
  );
};
